import { faPlusCircle, faSearch } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import moment from 'moment-timezone';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { withRouter } from 'react-router-dom';
import ReactTable from 'react-table-v6';
import 'react-table-v6/react-table.css';
import PageToggleButton from '../../../../Common/PageToggleButton';
import { Pagination } from '@mui/material';
import { Config } from '../../../../../shared/config';
import modelService from './../../../modelService';


const filterArrRes = [];

class CustomerList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            customerData: [],
            noRecordsMessage: null,
            showPagination: false,
            rowsPerPage: 10,
            page: 1,
            totalCount: 0,
            total: 0,
            filterInUse: false
        };
        this.modelService = new modelService();
    }
    

    /**
     * Ui elements rendering
     */
    render() {
        const { customerData, noRecordsMessage, showPagination ,totalCount, page, rowsPerPage,  filterInUse} = this.state;
        return (
            <>
                <div className="model-list-box customer-list-table">
                    <div className="add-button-container pull-right">
                        <Button className="add-cust-btn text-center btn-sm" onClick={this.addNewCustomer}>
                            <FontAwesomeIcon className="btn-icon" icon={faPlusCircle} />
                            <span className="ml-2">Add Customer</span>
                        </Button>
                    </div>
                    <div className="table-responsive-cm">
                        <ReactTable
                            filterable
                            defaultFilterMethod={(filter, row) =>
                                row[filter.id] !== undefined
                                    ? String(row[filter.id]).toLowerCase().includes(filter.value.toLowerCase())
                                    : false
                            }
                            columns={[
                                {
                                    Header: 'Customer Name',
                                    accessor: 'customerName',
                                    width: 200,
                                    Filter: ({filter, onChange}) => this.filterRender(filter, onChange, 'customerName'),
                                },
                                {
                                    Header: 'CRM Customer ID',
                                    accessor: 'crmCustomerId',
                                    Filter: ({filter, onChange}) => this.filterRender(filter, onChange, 'crmCustomerId'),
                                },
                                {
                                    Header: 'Address',
                                    accessor: 'address',
                                    Filter: ({filter, onChange}) => this.filterRender(filter, onChange, 'address'),
                                },
                                {
                                    Header: 'Customer Type',
                                    accessor: 'customerType',
                                    Filter: ({filter, onChange}) => this.filterRender(filter, onChange, 'customerType'),
                                },
                                {
                                    Header: 'Status',
                                    accessor: 'status',
                                    Filter: ({filter, onChange}) => this.filterRender(filter, onChange, 'status'),
                                },
                                {
                                    Header: 'Modified Date',
                                    accessor: 'modifiedDate',
                                    Cell: (props) => {
                                        const modifiedDate = props.value
                                            ? moment.utc(props.value, Config.UI_TIMESTAMP_FORMAT).local()
                                            : '';
                                        return props.value
                                            ? moment(modifiedDate, Config.API_TIMESTAMP_FORMAT).format(
                                                  Config.UI_TIMESTAMP_FORMAT,
                                              )
                                            : '';
                                    },
                                    sortMethod: (a, b) => {
                                        var a1 = new Date(a).getTime();
                                        var b1 = new Date(b).getTime();
                                        if (a1 > b1) return 1;
                                        else if (a1 < b1) return -1;
                                        else return 0;
                                    },
                                    Filter: ({filter, onChange}) => this.filterRender(filter, onChange, 'modifiedDate'),
                                },
                                {
                                    Header: 'Modified By',
                                    accessor: 'modifiedBy',
                                    Filter: ({filter, onChange}) => this.filterRender(filter, onChange, 'modifiedBy'),
                                },
                                {
                                    Header: () => <div style={{ textAlign: 'center' }}>Action</div>,
                                    Cell: MyCell,
                                    getProps: (state, rowInfo) => ({
                                        onClick: () => {
                                            this.modelTableRowClick(rowInfo);
                                        },
                                    }),
                                    className: 'td-button-outer',
                                    minWidth: 110,
                                    filterable: false
                                },
                            ]}
                            data={customerData}
                            noDataText={noRecordsMessage}
                            minRows={customerData.length}
                            showPagination={showPagination}
                            pageSize={customerData.length}
                            className="-highlight cursor-pointer w-100"
                            style={
                                customerData.length >= 1
                                    ? {
                                          height: 'calc(100vh - 290px)',
                                      }
                                    : {}
                            }
                            defaultSorted={[{ id: 'modifiedDate', desc: true }]}
                        />
                    </div>
                    <div className='pagination-div'>
                        <Pagination  showFirstButton showLastButton disabled = {filterInUse}
                            component="div"
                            count={totalCount}
                            page={page}
                            rowsPerPage={rowsPerPage}
                            onChange={this.handleChangePage}
                            variant="outlined"
                            shape="rounded"
                            sx={{
                                ".MuiPaginationItem-root": {
                                    fontSize: '16px',
                                    marginTop: '15px',
                                },
                                ".Mui-selected": {
                                    backgroundColor: '#135d87 !important',
                                    color:'#fff',
                                }
                            }}
                        />
                        <PageToggleButton rowsPerPageOptions={[10,20,50,100]} filterInUse = {filterInUse}
                                        perPageCount= {rowsPerPage}  
                                        rowsPerPage={(perPage) => {this.setState({rowsPerPage: perPage}); 
                                        this.onPageOrPageLoadChange(1, perPage)}}/>
                    </div>
                </div>
            </>
        );
    }

    /**
     * On row click
     * @param {*} rowInfo row information
     */
    modelTableRowClick(rowInfo) {
        this.props.history.push('/model/admin/customer/' + rowInfo.original.customerId);
    }

    /**
     * Add new customer
     */
    addNewCustomer = () => {
        this.props.history.push('/model/admin/customer');
    };

    /**
     * Component mount method
     */
    componentDidMount() {
        this.modelService.getCustomersList().then((res) => {
            if (res && res.status === 'Success' && res.data ) {
                const { totalPages, data, total } = paginateUI(res.data, 10, 1);
                this.setState({
                    customerData: data,
                    noRecordsMessage: null,
                    page: 1,
                    totalCount: totalPages,
                    total: total
                });
            } else {
                this.setState({
                    customerData: [],
                    noRecordsMessage: '-No Customers Found-',
                });
            }
        });
    }

    async onPageOrPageLoadChange(newPage, perPage){
        this.modelService.getCustomersList(newPage, perPage).then((res) => {
            if (res && res.status === 'Success' && res.data ) {
                const { data, totalPages } =  paginateUI(res.data, perPage, newPage);
                this.setState({
                    customerData: data,
                    noRecordsMessage: null,
                    totalCount: totalPages,
                    page: parseInt(newPage, 10),
                });    
            } else {
                this.setState({
                    customerData: [],
                    noRecordsMessage: '-No Customers Found-',
                });
            }
        });
    }

    handleChangePage = async (event, newPage) => {
        this.setState({page: newPage});
        this.modelService.getCustomersList(newPage, this.state.rowsPerPage).then((res) => {
            if (res && res.status === 'Success' && res.data ) {
                const {data} =  paginateUI(res.data, this.state.rowsPerPage, newPage);
                this.setState({
                    customerData: data,
                    noRecordsMessage: null,
                });

            } else {
                this.setState({
                    customerData: [],
                    noRecordsMessage: '-No Customers Found-',
                });
            }
        });
    };

    onFilterRenderChange = async (event, field) => {
        const { customerData, total , rowsPerPage, page} = this.state;
       
        if(field){
            if (!event.target.value){
                filterArrRes.pop(field);
            } else if(!filterArrRes.includes(field)){
                filterArrRes.push(field);
            } 
        }
        if(!event.target.value && filterArrRes.length == 0){
            const {data} = await paginateUI(customerData, rowsPerPage, page);
            if (data && data.length > 0 ) {
            this.setState({
                    customerData: data,
                    filterInUse: false
                });
            }
        } else if(customerData.length != total){
            this.modelService.getCustomersList().then((res) => {
                if (res && res.status === 'Success' && res.data) {
                        this.setState({
                            customerData: res.data,
                            filterInUse: true
                        });
                    }
            });
        }  
    }

    filterRender = (filter, onChange, field) => {
        return (
            <div style={{position: 'relative', backgroundColor: '#FFFFFF', paddingLeft: '10px'}}>
            <FontAwesomeIcon icon={faSearch}  className='filter-search-icon' />
            <input
            onChange={event => { onChange(event.target.value) ; this.onFilterRenderChange(event, field)}}
            value={filter ? filter.value : ''}
            style={{
                width: '100%',
                border: '0px'
            }}
            />
        </div>
        )
    }
}

const paginateUI = (items, perPage, page) => {

    const offset = perPage * (page - 1);
    const totalPages = Math.ceil(items.length / perPage);
    const paginatedItems = items.slice(offset, perPage * page);
      
    return {
        previousPage: page - 1 ? page - 1 : null,
        nextPage: (totalPages > page) ? page + 1 : null,
        total: items.length,
        totalPages: totalPages,
        data: paginatedItems
    };
   
};

CustomerList.propTypes = {
    history: PropTypes.object.isRequired,
};

export default withRouter(CustomerList);

/**
 * To return button elements
 * @param {*} param0 Cell info
 */
export function MyCell({
    columnProps: {
        rest: { onClick },
    },
}) {
    return (
        <Row>
            <Col md={12} className="text-center table-buttons">
                <button className="btn-view" id="view-btn" value="view" onClick={onClick}>
                    View
                </button>
            </Col>
        </Row>
    );
}
MyCell.propTypes = {
    columnProps: PropTypes.shape({
        rest: PropTypes.shape({
            onClick: PropTypes.func,
            onClickRename: PropTypes.func,
        }),
    }),
};

